export const getClubSlugFromPatronPath = (
  pathname: string
): string | undefined => {
  const encodedSlug = pathname.match(/^\/patron\/club\/([^/]+)(?:\/|$)/)?.[1];

  if (!encodedSlug) return undefined;

  try {
    return decodeURIComponent(encodedSlug);
  } catch {
    return undefined;
  }
};
